var render = function render(){
  var _vm$form_sr$form_repa;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', {
    staticClass: "m-0"
  }, [(_vm$form_sr$form_repa = _vm.form_sr.form_repair) !== null && _vm$form_sr$form_repa !== void 0 && _vm$form_sr$form_repa.length ? _vm._l(_vm.form_sr.form_repair, function (item, index) {
    return _c('b-col', {
      key: index,
      staticClass: "mb-4",
      attrs: {
        "md": "12"
      }
    }, [_c('div', {
      staticClass: "border p-3 card-sr-information-form"
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('h5', {
      staticClass: "card-title text-primary"
    }, [_c('strong', [_vm._v("ITEM SERVICE & REPAIR")])])]), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "12"
      }
    }, [_c('label', {
      attrs: {
        "for": "equimnet-name"
      }
    }, [_vm._v("Equipment Name "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('v-select', {
      staticClass: "bg-white",
      attrs: {
        "options": _vm.optionEquipments,
        "label": "equipmentName",
        "placeholder": "Select Equipment Name",
        "clearable": false,
        "searchable": "",
        "track-by": "maintenance_master_id",
        "reduce": function reduce(itm) {
          return itm.maintenance_master_id;
        }
      },
      on: {
        "input": function input(val) {
          return _vm.handleChangeName(val, item);
        }
      },
      scopedSlots: _vm._u([{
        key: "search",
        fn: function fn(_ref) {
          var attributes = _ref.attributes,
            events = _ref.events;
          return [_c('input', _vm._g(_vm._b({
            staticClass: "vs__search",
            attrs: {
              "required": !item.maintenance_master_id
            }
          }, 'input', attributes, false), events))];
        }
      }], null, true),
      model: {
        value: item.maintenance_master_id,
        callback: function callback($$v) {
          _vm.$set(item, "maintenance_master_id", $$v);
        },
        expression: "item.maintenance_master_id"
      }
    }), item.maintenance_master_id == 'other' ? _c('b-form-input', {
      staticClass: "bg-white mt-3 rounded-sm",
      attrs: {
        "required": "",
        "placeholder": "inpiut Other Name",
        "id": "work-item"
      },
      model: {
        value: item.other_name,
        callback: function callback($$v) {
          _vm.$set(item, "other_name", $$v);
        },
        expression: "item.other_name"
      }
    }) : _vm._e()], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "work-item"
      }
    }, [_vm._v("Work Item "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('b-form-input', {
      staticClass: "bg-white rounded-sm",
      attrs: {
        "required": "",
        "placeholder": "Input Work Item",
        "id": "work-item"
      },
      model: {
        value: item.title,
        callback: function callback($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3 rounded-sm",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "type-rm"
      }
    }, [_vm._v("Type R & M "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('b-form-select', {
      staticClass: "bg-white rounded-sm",
      attrs: {
        "placeholder": "Select Type R & M",
        "plain": "",
        "name": "work_item",
        "id": "type-rm",
        "options": _vm.optionsTaskType,
        "required": ""
      },
      model: {
        value: item.task_type_id,
        callback: function callback($$v) {
          _vm.$set(item, "task_type_id", $$v);
        },
        expression: "item.task_type_id"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "date"
      }
    }, [_vm._v("Department "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('b-form-select', {
      staticClass: "bg-white rounded-sm",
      attrs: {
        "placeholder": "Select Department",
        "plain": "",
        "name": "department",
        "options": _vm.optionsDepartment,
        "required": ""
      },
      model: {
        value: item.department_id,
        callback: function callback($$v) {
          _vm.$set(item, "department_id", $$v);
        },
        expression: "item.department_id"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "repair-section"
      }
    }, [_vm._v("Repair Section "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('b-form-select', {
      staticClass: "bg-white rounded-sm",
      attrs: {
        "plain": "",
        "name": "repair-section",
        "required": ""
      },
      model: {
        value: item.section,
        callback: function callback($$v) {
          _vm.$set(item, "section", $$v);
        },
        expression: "item.section"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": null
      }
    }, [_vm._v("-- Seelct Repair Section --")]), _c('b-form-select-option', {
      attrs: {
        "value": 'DECK'
      }
    }, [_vm._v("Deck")]), _c('b-form-select-option', {
      attrs: {
        "value": 'ENGINE'
      }
    }, [_vm._v("Engine")])], 1)], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "category"
      }
    }, [_vm._v("Category "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('b-form-select', {
      staticClass: "bg-white rounded-sm",
      attrs: {
        "placeholder": "Select Category",
        "plain": "",
        "name": "category",
        "options": _vm.optionsCategory,
        "required": ""
      },
      model: {
        value: item.category_id,
        callback: function callback($$v) {
          _vm.$set(item, "category_id", $$v);
        },
        expression: "item.category_id"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "classification"
      }
    }, [_vm._v("Classification "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('b-form-select', {
      staticClass: "bg-white rounded-sm",
      attrs: {
        "placeholder": "Select Classification",
        "plain": "",
        "name": "classification",
        "options": _vm.optionsClassification,
        "required": ""
      },
      on: {
        "change": function change($event) {
          return _vm.handleCountDaysBasedClassification(item);
        }
      },
      model: {
        value: item.classification_id,
        callback: function callback($$v) {
          _vm.$set(item, "classification_id", $$v);
        },
        expression: "item.classification_id"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "cause"
      }
    }, [_vm._v("Cuase "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('b-form-select', {
      staticClass: "bg-white rounded-sm",
      attrs: {
        "placeholder": "Select Cuase",
        "plain": "",
        "name": "cause",
        "options": _vm.optionsCause,
        "required": ""
      },
      model: {
        value: item.case_id,
        callback: function callback($$v) {
          _vm.$set(item, "case_id", $$v);
        },
        expression: "item.case_id"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "kind-of-task"
      }
    }, [_vm._v("Kind Of Task "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('b-form-select', {
      staticClass: "bg-white rounded-sm",
      attrs: {
        "placeholder": "Select Kind Of Task",
        "plain": "",
        "name": "kind-of-task",
        "options": _vm.optionsKindTask,
        "required": ""
      },
      model: {
        value: item.kind_task_id,
        callback: function callback($$v) {
          _vm.$set(item, "kind_task_id", $$v);
        },
        expression: "item.kind_task_id"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "start-date"
      }
    }, [_vm._v("Est. Start Date "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('date-picker', {
      staticClass: "w-100",
      attrs: {
        "placeholder": "Select Est. Start Date",
        "id": "start-date"
      },
      on: {
        "change": function change($event) {
          return _vm.handleCountDaysBasedClassification(item);
        }
      },
      model: {
        value: item.start_at,
        callback: function callback($$v) {
          _vm.$set(item, "start_at", $$v);
        },
        expression: "item.start_at"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "finish-date"
      }
    }, [_vm._v("Est. Finish Date "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('date-picker', {
      staticClass: "w-100",
      attrs: {
        "placeholder": "Select Est. Finish Date",
        "id": "finish-date",
        "disabled": !item.start_at,
        "disabled-date": function disabledDate(date) {
          return _vm.disableFinishDates(date, item.start_at);
        }
      },
      on: {
        "change": function change($event) {
          return _vm.calculateDays(item);
        }
      },
      model: {
        value: item.estimated_finished_at,
        callback: function callback($$v) {
          _vm.$set(item, "estimated_finished_at", $$v);
        },
        expression: "item.estimated_finished_at"
      }
    })], 1), _c('b-col', {
      staticClass: "mb-3",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "work-location"
      }
    }, [_vm._v("Est. Cost Repair Per Item "), _c('span', {
      staticClass: "text-red"
    }, [_vm._v("*")])]), _c('InputCurrency', {
      staticClass: "bg-white rounded-sm",
      attrs: {
        "placeholder": "0.00",
        "type": "number",
        "required": ""
      },
      model: {
        value: item.cost_estimate,
        callback: function callback($$v) {
          _vm.$set(item, "cost_estimate", $$v);
        },
        expression: "item.cost_estimate"
      }
    })], 1), _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "attachment"
      }
    }, [_vm._v("Item Attachment anjing")]), _c('InputFileMultiple', {
      attrs: {
        "labelKey": "input-file-sr-item-".concat(index),
        "files": item.filePreview
      },
      on: {
        "change-files": function changeFiles(val) {
          return _vm.handleInputFilesItem(val, item);
        }
      }
    }), _vm._l(item.filePreview, function (url, idx) {
      return _c('div', {
        key: "".concat(index, "-").concat(idx),
        staticClass: "p-0 pr-2 pb-2",
        staticStyle: {
          "max-width": "200px"
        }
      }, [_c('AttachmentSR', {
        attrs: {
          "modelId": item.id,
          "modelName": "sr_form_repair",
          "file": url
        },
        on: {
          "success-delete": function successDelete(path) {
            return _vm.deleteFile(path, item);
          },
          "delete": function _delete() {
            return _vm.handleDeleteFile(item, idx);
          }
        }
      })], 1);
    })], 2), _c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('label', {
      attrs: {
        "for": "remark"
      }
    }, [_vm._v("Item Remarks")]), _c('b-form-textarea', {
      staticClass: "bg-white",
      attrs: {
        "id": "remark rounded-sm",
        "placeholder": "input remarks...",
        "rows": "3"
      },
      model: {
        value: item.description,
        callback: function callback($$v) {
          _vm.$set(item, "description", $$v);
        },
        expression: "item.description"
      }
    })], 1)], 1)], 1)]);
  }) : _vm._e(), _c('b-col', {
    staticClass: "my-5 d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Cancel & Close")]), !_vm.multipleSelected.length ? _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.addForm
    }
  }, [_vm._v("Add Form")]) : _vm._e(), !_vm.loading ? _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Save & Close")]) : _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)], 1)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }